import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../html/element'
import { Icon } from '../../../html/icon'
import TextEllipsis from '../../../textEllipsis'
import styles from './index.module.scss'

export const GroupCriteria = ({
  label,
  data,
  onClickDelete,
  isFlex,
  notHidden,
  isAll,
  renderWhenStatusAll,
}) => {
  if (!notHidden && data.length === 0) return <></>

  return (
    <div
      className={styles.groupCriteria}
      style={{ display: isFlex ? 'flex' : 'block' }}
    >
      {label && (
        <div
          className={styles.title}
          style={{
            paddingBottom: isFlex ? '' : '8px',
          }}
        >
          <div>
            <Translate value={label} />
          </div>
        </div>
      )}
      {isAll ? (
        <>{renderWhenStatusAll && renderWhenStatusAll()}</>
      ) : (
        <div className={styles.content} style={{ flex: 1 }}>
          {data?.map((item, index) => (
            <Element
              className={styles.item}
              style={{ backgroundColor: '#F3F3F3', borderColor: '#E5E5E8' }}
              key={index}
            >
              <TextEllipsis
                appendStyle={{
                  color: '#191D25',
                  whiteSpace: 'nowrap',
                  maxWidth: 160,
                }}
                text={item.label}
              />

              <Icon
                className="icon-delete-circle-fill"
                style={{ color: '#9C9C9C' }}
                onClick={() => onClickDelete(item)}
              />
            </Element>
          ))}
        </div>
      )}
    </div>
  )
}

GroupCriteria.propTypes = {
  label: PropTypes.string,
  data: PropTypes.array,
  isFlex: PropTypes.bool,
  notHidden: PropTypes.bool,
  isAll: PropTypes.bool,
  renderWhenStatusAll: PropTypes.func,
}

GroupCriteria.defaultProps = {
  isFlex: true,
  notHidden: false,
  isAll: false,
  renderWhenStatusAll: () => {},
}
